let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Cp8t")).then(() => parcelRequire('g5buf'));